import { Error } from '@sparkpost/matchbox';

/**
 * Matchbox Error component
 * @see https://design.sparkpost.com/components/error/
 */
export default Error;
